import React from "react";
import "isomorphic-fetch";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import {
  Landing,
  Packages,
  Refer,
  Account,
  Help,
  Lockers,
  HelpExpanded,
  Coupons
} from "./views";
import Heap from "./components/HeapAnalytics/Heap";
import { NavBar } from "./components/Nav";
import { validateThenLogin } from "./actions/auth";
import { fetchUserData } from "./actions/userData";

class App extends React.Component {
  state = {
    showLoadingScreen: true,
    loggedIn: false,
    searchString: ""
  };

  async componentDidMount() {
    // will trigger props change if successful
    await this.props.validateThenLogin();
  }

  async componentWillReceiveProps(nextProps) {
    // check if redux state updated
    if (
      this.props.auth !== nextProps.auth ||
      this.props.userData !== nextProps.userData
    ) {
      // if not fetched yet
      if (nextProps.auth.loggedIn && !nextProps.userData.fetched) {
        this.setState({ showLoadingScreen: true });
        await this.props.fetchUserData();
        this.setState({ showLoadingScreen: false });
      } else {
        this.setState({
          loggedIn: false,
          showLoadingScreen: false
        });
      }
    }
  }

  handleSearchInput = e => {
    this.setState({ searchString: e.target.value || "" });
  };

  render() {
    if (this.state.showLoadingScreen)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            backgroundColor: "#FCFCFC"
          }}
        >
          <img
            src={require("./assets/loading/loading_box.gif")}
            alt="loading gif"
            style={{ margin: "0 auto" }}
          />
        </div>
      );

    return (
      <Router>
        <Heap />
        {this.props.auth.loggedIn ? (
          <div>
            <NavBar dashboard={true} onSearchChange={this.handleSearchInput} />
            <Switch>
              <Route
                path="/packages"
                render={props => (
                  <Packages {...props} searchValue={this.state.searchString} />
                )}
              />
              <Route path="/help/:subpage" component={HelpExpanded} />
              <Route path="/help" component={Help} />
              <Route path="/lockers" component={Lockers} />
              <Route path="/refer" component={Refer} />
              <Route path="/account" component={Account} />
              <Route path="/coupons" component={Coupons} />
              <Route path="/" render={() => <Redirect to="/packages" />} />
            </Switch>
          </div>
        ) : (
          <div>
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route render={() => <Redirect to="/" />} />
            </Switch>
          </div>
        )}
      </Router>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
  validateThenLogin: () => dispatch(validateThenLogin()),
  fetchUserData: () => dispatch(fetchUserData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
